import { createApp } from 'vue'
import App from './App.vue'
import './assets/tailwind.css'
import router from './router'
import store from './store'
import usercustom from './plugins/usercustom.js'

createApp(App)
  .use(store)
  .use(router)
  .use(usercustom)
  .mount('#app')
